export const LANGUAGES = [
  { code: 'fr', countryCode: 'FR', label: 'Français' },
  { code: 'en', countryCode: 'GB', label: 'English' },
  { code: 'es', countryCode: 'ES', label: 'Español' },
  { code: 'it', countryCode: 'IT', label: 'Italiano' },
  { code: 'pt', countryCode: 'PT', label: 'Português' },
  { code: 'de', countryCode: 'DE', label: 'Deutsch' },
  { code: 'nl', countryCode: 'NL', label: 'Nederlands' },
  { code: 'pl', countryCode: 'PL', label: 'Polski' },
  { code: 'sv', countryCode: 'SE', label: 'Svenska' },
  { code: 'da', countryCode: 'DK', label: 'Dansk' },
  { code: 'fi', countryCode: 'FI', label: 'Suomi' },
  { code: 'no', countryCode: 'NO', label: 'Norsk' },
  { code: 'el', countryCode: 'GR', label: 'Ελληνικά' },
  { code: 'cs', countryCode: 'CZ', label: 'Čeština' },
  { code: 'ro', countryCode: 'RO', label: 'Română' },
  { code: 'hu', countryCode: 'HU', label: 'Magyar' },
  { code: 'bg', countryCode: 'BG', label: 'Български' },
];
